/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UserInformationBox_UserFragmentDoc } from '../../features/users/UserInformationBox.generated.js';
import { UserRolesForm_UserFragmentDoc } from '../../features/users/UserRolesForm.generated.js';
import { MyOrganisationUserAvatarAndTitleData_UserFragmentDoc } from '../../features/organisations/MyOrganisationUserAvatarAndTitle.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyOrganisationUserProfileQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type MyOrganisationUserProfileQuery = { user?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'User', id: string, membershipStatus: Types.OrganisationMembershipStatus, firstname: string, familyname: string, jobTitle: string, email: any, title: Types.Salutation, organisationTitle: string, organisationId: string, membershipInvitation?: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } | null, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, type: Types.PhoneType, main: boolean, number: string }>, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null, viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, representive?: { __typename: 'User', id: string } | null } } | null };

export type SetMemberAsOrganisationRepresentativeMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type SetMemberAsOrganisationRepresentativeMutation = { setOrganisationRepresentative: { __typename: 'SetOrganisationRepresentativeResult', organisation: { __typename: 'ViewerOrganisation', id: string, representive?: { __typename: 'User', id: string } | null } } };

export type CancelInvitationMutationVariables = Types.Exact<{
  organisationMembershipInvitationId: Types.Scalars['ID']['input'];
}>;


export type CancelInvitationMutation = { cancelOrganisationMembershipInvitation: { __typename: 'CancelOrganisationMembershipInvitationResult', invitation: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } } };


export const MyOrganisationUserProfileDocument = gql`
    query MyOrganisationUserProfile($userId: ID!) {
  user(id: $userId) {
    ... on User {
      id
      membershipStatus
      membershipInvitation {
        id
        status
      }
      firstname
      familyname
      ...UserInformationBox_User
      ...UserRolesForm_User
      ...MyOrganisationUserAvatarAndTitleData_User
    }
  }
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        representive {
          id
        }
      }
    }
  }
}
    ${UserInformationBox_UserFragmentDoc}
${UserRolesForm_UserFragmentDoc}
${MyOrganisationUserAvatarAndTitleData_UserFragmentDoc}`;

/**
 * __useMyOrganisationUserProfileQuery__
 *
 * To run a query within a React component, call `useMyOrganisationUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrganisationUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrganisationUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMyOrganisationUserProfileQuery(baseOptions: Apollo.QueryHookOptions<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables> & ({ variables: MyOrganisationUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>(MyOrganisationUserProfileDocument, options);
      }
export function useMyOrganisationUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>(MyOrganisationUserProfileDocument, options);
        }
export function useMyOrganisationUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>(MyOrganisationUserProfileDocument, options);
        }
export type MyOrganisationUserProfileQueryHookResult = ReturnType<typeof useMyOrganisationUserProfileQuery>;
export type MyOrganisationUserProfileLazyQueryHookResult = ReturnType<typeof useMyOrganisationUserProfileLazyQuery>;
export type MyOrganisationUserProfileSuspenseQueryHookResult = ReturnType<typeof useMyOrganisationUserProfileSuspenseQuery>;
export type MyOrganisationUserProfileQueryResult = Apollo.QueryResult<MyOrganisationUserProfileQuery, MyOrganisationUserProfileQueryVariables>;
export const SetMemberAsOrganisationRepresentativeDocument = gql`
    mutation SetMemberAsOrganisationRepresentative($organisationId: ID!, $userId: ID!) {
  setOrganisationRepresentative(
    input: {organisationId: $organisationId, userId: $userId}
  ) {
    organisation {
      id
      representive {
        id
      }
    }
  }
}
    `;
export type SetMemberAsOrganisationRepresentativeMutationFn = Apollo.MutationFunction<SetMemberAsOrganisationRepresentativeMutation, SetMemberAsOrganisationRepresentativeMutationVariables>;

/**
 * __useSetMemberAsOrganisationRepresentativeMutation__
 *
 * To run a mutation, you first call `useSetMemberAsOrganisationRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberAsOrganisationRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberAsOrganisationRepresentativeMutation, { data, loading, error }] = useSetMemberAsOrganisationRepresentativeMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetMemberAsOrganisationRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<SetMemberAsOrganisationRepresentativeMutation, SetMemberAsOrganisationRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMemberAsOrganisationRepresentativeMutation, SetMemberAsOrganisationRepresentativeMutationVariables>(SetMemberAsOrganisationRepresentativeDocument, options);
      }
export type SetMemberAsOrganisationRepresentativeMutationHookResult = ReturnType<typeof useSetMemberAsOrganisationRepresentativeMutation>;
export type SetMemberAsOrganisationRepresentativeMutationResult = Apollo.MutationResult<SetMemberAsOrganisationRepresentativeMutation>;
export type SetMemberAsOrganisationRepresentativeMutationOptions = Apollo.BaseMutationOptions<SetMemberAsOrganisationRepresentativeMutation, SetMemberAsOrganisationRepresentativeMutationVariables>;
export const CancelInvitationDocument = gql`
    mutation CancelInvitation($organisationMembershipInvitationId: ID!) {
  cancelOrganisationMembershipInvitation(
    organisationMembershipInvitationId: $organisationMembershipInvitationId
  ) {
    invitation {
      id
      status
    }
  }
}
    `;
export type CancelInvitationMutationFn = Apollo.MutationFunction<CancelInvitationMutation, CancelInvitationMutationVariables>;

/**
 * __useCancelInvitationMutation__
 *
 * To run a mutation, you first call `useCancelInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvitationMutation, { data, loading, error }] = useCancelInvitationMutation({
 *   variables: {
 *      organisationMembershipInvitationId: // value for 'organisationMembershipInvitationId'
 *   },
 * });
 */
export function useCancelInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CancelInvitationMutation, CancelInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInvitationMutation, CancelInvitationMutationVariables>(CancelInvitationDocument, options);
      }
export type CancelInvitationMutationHookResult = ReturnType<typeof useCancelInvitationMutation>;
export type CancelInvitationMutationResult = Apollo.MutationResult<CancelInvitationMutation>;
export type CancelInvitationMutationOptions = Apollo.BaseMutationOptions<CancelInvitationMutation, CancelInvitationMutationVariables>;